import { createContext } from "react"

export const OpeningContext = createContext({})
